import React, { Component } from 'react';
import { Dialog, Button, DialogTitle, DialogContent, DialogActions, DialogContentText, Icon, TextField, Snackbar } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Http from '../../Http';
import { DownloadFileComponent } from "../../helpers";
import PDFViewer from '../pdfViewer'
import './acciones.css'
import { AuthContext } from '../../context/authContext';
import ACCESS from '../../ACCESS';

class AccionesPreGuia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSG: false,
      openSF: false,
      openPrint: false,
      alertDialog: {
        open: false,
        title: '',
        content: '',
        onCancel: () => {},
        onAccept: () => {},
      },
      snackbar: {
        open: false,
        message: '',
      },
      searchOptions: [],
      searcFoliohOptions: [],
      pdfURL: '',
    }
  }
  
  setOpenSg = (openSG)  => {
    this.setState({openSG})
  }
  setOpenSF = (openSF)  => {
    this.setState({openSF})
  }
  setOpenPrint = (openPrint)  => {
    this.setState({openPrint})
  }
  setAlertDialog = (alertDialog)  => {
    this.setState({alertDialog})
  }
  setSnackbar = (snackbar)  => {
    this.setState({snackbar})
  }
  setSearchOptions = (searchOptions)  => {
    this.setState({searchOptions})
  }
  setSearcFoliohOptions = (searcFoliohOptions)  => {
    this.setState({searcFoliohOptions})
  }
  setPdfURL = (pdfURL)  => {
    this.setState({pdfURL})
  }

  preguiaSelectChange = async (value) => {
    this.props.history.push(`/Preguia/${value.id}`);
    this.setOpenSg(false)
  }

  valueSearchChange = async (value) => {
    const Res = await Http.get(`preguia/form?preguia_folio=${value}`);
    if (!Res.error) {
      const { preguias } = Res.data;
      this.setSearchOptions(preguias);
    }
  }

  handleCancelClick = () => {
    this.setAlertDialog({
      open: true,
      title: 'Cancelar Preguía',
      content: '¿Realmente Quiere Cancelar la Preguía?',
      onAccept: this.handleCancelGuia,
      onCancel: () => {},
    });
  }

  handlePrintClick = async (id) => {
    const Resp = await Http.get(`preguia/recoleccion/pdf/${id ? id : this.props.match.params.id}`, true, 'arraybuffer');
    if (Resp) {
      this.id_guia = id;
      const blob = new Blob([Resp], { type: 'application/pdf' })
      this.setPdfURL(URL.createObjectURL(blob));
      this.setOpenPrint(true);
    }
  }

  handlePrintPdf = async () => {
    const { pdfURL, alertDialog } = this.state;
    const printWin = window.open(pdfURL, 'Preguia', 'width=1050,height=800');
    printWin.focus();
    printWin.print();
    URL.revokeObjectURL(pdfURL);
    this.setPdfURL('');
    this.setAlertDialog({ ...alertDialog, open: false});
    this.setOpenPrint(false);
    // esto es cuando se imprime al momento de crearla
    if (this.id_guia) {
      this.props.history.push(`/Preguias/Todas`);
    }
  }

  handleCancelGuia = async () => {
    const { alertDialog } = this.state;
    this.setAlertDialog({ ...alertDialog, open: false })
    const Resp = await Http.post(`preguia/${this.props.match.params.id}/cancelar`);
    if (!Resp.error) {
      this.setSnackbar({ open: true, message: 'Preguía Cancelada' });
      this.props.history.push(`/Preguias/Todas`);
    } else {
      this.setSnackbar({
        open: true,
        message: 'Ocurrio un error al imprimir la Preguía'
      });
    }
  }

  handleAcceptPrint = () => {
    this.handlePrintPdf();
  }

  render() {
    const { modo } = this.props;
    const { hasAccess } = this.context;
    const { openSG, searchOptions, pdfURL, openPrint, alertDialog, snackbar } = this.state;
  return (
    <div style={{ margin: '10px', padding: '10px', boxShadow: '1px 1px 6px 1px #00000022', }} >
      <DownloadFileComponent />
      <div style={{ display: 'flex', justifyContent: 'space-between' }} >
        <Button
          variant="contained"
          endIcon={<Icon>search</Icon>}
          onClick={() => { this.setOpenSg(!openSG) }}
        >
          Buscar
        </Button>
        {hasAccess(ACCESS.PREGUIA.IMPRIMIR_PREGUIA) && (
          <Button
            variant="contained"
            endIcon={<Icon>print</Icon>}
            onClick={() => this.handlePrintClick()}
          >
            Visualizar Impresion
        </Button>
        )}
        {(this.props.pg_estado !== 0 && hasAccess([ACCESS.PREGUIA.EDITAR_PREGUIAS_CREADAS_POR_EL_USUARIO, ACCESS.PREGUIA.EDITAR_PREGUIAS_SUCURSAL_DEL_USUARIO,
          ACCESS.PREGUIA.EDITAR_TODAS_PREGUIAS
        ]) && this.props.pg_estado === 1 &&
          <Button
            color="secondary"
            variant="contained"
            endIcon={<Icon>block</Icon>}
            onClick={this.handleCancelClick}
          >
            Cancelar PreGuía
        </Button>
        )}
      </div>

      <div>
        {/* BUSQUEDA DE PREGUIAS */}
        <Dialog onClose={() => { this.setOpenSg(false) }} open={openSG}>
          <DialogTitle onClose={() => { this.setOpenSg(false) }}>
            Buscar Preguia
          </DialogTitle>
          <DialogContent dividers>
            <div>
              <Autocomplete
                options={searchOptions}
                disableClearable
                getOptionLabel={option => option.id}
                onChange={(e, val) => { this.preguiaSelectChange(val) }}
                renderInput={params => (
                  <TextField
                    style={{ minWidth: '200px' }}
                    {...params}
                    label='Buscar preguia'
                    variant="outlined"
                    onChange={(e) => { this.valueSearchChange(e.target.value) }}
                    margin="normal"
                  />
                )}
              />
            </div>
          </DialogContent>
        </Dialog>

        {/* VISUALIZAR IMPRESION */}
        <Dialog fullWidth={true} maxWidth={'lg'} onClose={() => { this.setOpenPrint(false) }} open={openPrint} >
          <DialogTitle onClose={() => { this.setOpenPrint(false) }}>
            Preguia { this.id_guia ||  this.props.match.params.id }
          </DialogTitle>
          <DialogContent dividers >
            <div>
              {
                pdfURL !== '' && (
                  <>
                    <div className='pdf-viewer'>
                      <PDFViewer
                        pdfUrl={pdfURL}
                      />
                    </div>
                    <div style={{ padding: '10px 15px 0', display: 'flex', width: '100%', justifyContent: 'space-between' }} >
                      <Button
                        variant="contained"
                        onClick={() => { 
                          this.setOpenPrint(false);
                          if (this.id_guia) {
                            this.props.history.push(`/Preguias/Todas`);
                          }
                        }}
                      >
                        Cerrar
                      </Button>
                      <Button
                        variant="contained"
                        endIcon={<Icon>print</Icon>}
                        onClick={this.handleAcceptPrint}
                      >
                        Imprimir
                      </Button>
                    </div>
                  </>
                )
              }
            </div>
          </DialogContent>
        </Dialog>

        {/* MODAL ALERTA */}
        <Dialog
          open={alertDialog.open}
          onClose={() => { this.setAlertDialog({...alertDialog, open: false }); alertDialog.onCancel() }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{alertDialog.title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {alertDialog.content}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { this.setAlertDialog({ ...alertDialog, open: false }); alertDialog.onCancel() }} color="primary">
              Cerrar
            </Button>
            <Button onClick={alertDialog.onAccept} color="primary" autoFocus>
              Aceptar
          </Button>
          </DialogActions>
        </Dialog> 
        
        {/* SNACKBAR MESSAGES */}
        <Snackbar
            open={snackbar.open}
            onClose={() => {this.setSnackbar({ open: false, message: '' })}}
            autoHideDuration={6000}
            Contentprops={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">{snackbar.message}</span>}
          />

      </div>
    </div>
  )
}
}

AccionesPreGuia.contextType = AuthContext;
export default AccionesPreGuia;